function reloadVariantSections({ data: { event, target, selectedOptionValues } }) {
  const targets = document.querySelectorAll('.js-reload-on-variant');

  targets.forEach((target) => {
    const sectionId = target.dataset.section;
    const url = new URL(window.location.href);

    url.searchParams.set('option_values', selectedOptionValues.join(','));
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, 'text/html');
        const newSection = newDoc.getElementById(`shopify-section-${sectionId}`);

        if (newSection) {
          target.innerHTML = newSection.innerHTML;
        }
      })
      .catch((error) => {
        console.error(`Error loading section ${sectionId}:`, error);
      });
  });
}

subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, reloadVariantSections);
